<template>
    <el-table :data="tableData" border style="width: 100%">
        <el-table-column
            label="序号"
            align="center"
            width="50"
            type="index"
        ></el-table-column>
        <el-table-column
            v-for="(item, index) in data.columnList"
            :key="index"
            :label="item.label"
            :prop="item.prop"
            align="center"
        >
            <template #default="scope" v-if="item.prop === 'userType'">
                {{ userTypeInfo[scope.row.userType] || "" }}
            </template>
            <template #default="scope" v-else-if="item.prop === 'paymentMethod'">
                {{ scope.row.paymentMethod == 1 ? "充值" : "消费" }}
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
            <template #default="scope">
                <el-button
                    type="primary"
                    size="mini"
                    @click="handleEdit(scope.row)">
                    查看
                </el-button>
                <el-button
                    type="primary"
                    size="mini"
                    @click="handleDelete(scope.row)">
                    删除
                </el-button>
            </template>
        </el-table-column>
    </el-table>

    <!-- 视频预览弹窗 -->
    <el-dialog
        v-model="data.showVideoPreview"
        title="视频预览"
        width="800px"
        append-to-body
        destroy-on-close
    >
        <div class="video-preview-container" style="padding: 20px; text-align: center;">
            <!-- 视频播放组件：优化配置 -->
            <video
                v-if="data.videoUrl"
                controls
                width="100%"
                style="max-height: 500px;"
                poster=""
                preload="metadata"
                playsinline
                webkit-playsinline
            >
            <!-- 增加多格式兼容 + 错误提示 -->
            <source :src="`${baseUrl}${data.videoUrl}`" type="video/mp4">
            <source :src="`${baseUrl}${data.videoUrl}`" type="video/webm">
            <source :src="`${baseUrl}${data.videoUrl}`" type="video/ogg">
            您的浏览器不支持HTML5视频播放，请升级浏览器或更换Chrome/Firefox浏览器！
            </video>
            <!-- 加载中提示 -->
            <div v-else class="loading-tip">
                <el-icon><Loading /></el-icon>
                <span>视频加载中...</span>
            </div>
        </div>
    </el-dialog>

    <!-- 审核 -->
    <audit-user ref="AuditUserRef" :currentData="data.currentData"></audit-user>
    <!-- 修改 用户信息 -->
    <add-edit-user
        ref="AddEditUserRef"
        scene="edit"
        :currentData="data.currentData"
    ></add-edit-user>
</template>

<script>
import { reactive } from "@vue/reactivity";
import {computed, inject, ref, onMounted} from "vue";
import AuditUser from "./children/audit-user.vue";
import AddEditUser from "./children/add-edit-user.vue";
import { ElMessage, ElMessageBox, ElIcon, Loading } from "element-plus";
import { VipVideoDelete } from "@/api/requestApis";

export default {
    props: {
        tableData: Array,
    },
    components: {
        AuditUser,
        AddEditUser,
        ElIcon,
        Loading
    },
    setup() {
        const userTypeInfo = inject("userTypeInfo");
        const AddEditUserRef = ref(null);
        const AuditUserRef = ref(null);
        const handleUpdateTable = inject("handleUpdateTable");

        // 获取当前页面的基础地址
        const baseUrl = computed(() => {
            return window.location.origin;
        })

        const data = reactive({
            currentData: {},
            columnList: [
                {
                    label: "ID",
                    prop: "id",
                },
                {
                    label: "视频名称",
                    prop: "fileName",
                },
                {
                    label: "备注",
                    prop: "remark",
                }
            ],
            showVideoPreview: false,
            videoUrl: ""
        });

        // 完善查看功能：增加视频加载错误处理
        const handleEdit = (val) => {
            data.currentData = val;
            data.videoUrl = `/api/fileUpload/preview/${val.id}`;
            data.showVideoPreview = true;

            // 重置视频状态（避免缓存导致的播放问题）
            setTimeout(() => {
                const videoEl = document.querySelector('.video-preview-container video');
                if (videoEl) {
                    videoEl.load(); // 重新加载视频
                    // 监听视频加载错误
                    videoEl.onerror = () => {
                        ElMessage.error("视频加载失败，请检查视频格式或服务器配置");
                    };
                }
            }, 100);
        };

        const handleDelete = (val) => {
            ElMessageBox.confirm("此操作将永久删除, 是否继续?", "提示", {}).then(() => {
                VipVideoDelete(val).then(() => {
                    ElMessage({
                        type: "success",
                        message: "删除成功",
                    });
                    handleUpdateTable();
                }).catch(() => {
                    ElMessage({
                        type: "error",
                        message: "删除失败",
                    });
                });
            });
        };

        const handleAudit = (val) => {
            data.currentData = val;
            AuditUserRef.value.handleToggle(true);
        };

        return {
            AddEditUserRef,
            AuditUserRef,
            handleAudit,
            handleEdit,
            handleDelete,
            data,
            baseUrl,
            userTypeInfo,
        };
    },
};
</script>

<style scoped>
.video-preview-container {
    background-color: #f5f5f5;
    border-radius: 4px;
}

.loading-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 300px;
    color: #666;
    font-size: 16px;
    gap: 8px;
}

video {
    border-radius: 4px;
    background-color: #000;
    /* 修复视频加载时的黑框问题 */
    object-fit: contain;
}

/* 增加视频加载错误样式提示 */
video::after {
    content: attr(error);
    color: #f56c6c;
    font-size: 14px;
}
</style>
